export const unassignedTradeId: string = 'unassigned';
export const guestTradeId: string = 'guest';
export const hoistTradeId: string = 'hoist';
export const scissorsLiftTradeId: string = 'scissorsLift';
export const safetyManagerTradeId: string = 'safetyManager';
export const trusstorTradeId: string = 'trusstor';
export const othersTradeGroup: string = 'others';
export const managementTradeGroup: string = 'management';
export const hoistOperatorTradeId: string = 'hoistOperator';
